import { cardTypesConstants } from "../constants/action.constants";

const initialState = {
  fetching: false,
  fetched: false,
  response: null,
  error: null
};

export const cardTypes = (state = initialState, action) => {
  switch (action.type) {
    case cardTypesConstants.GET_CARDTYPES_REQUEST:
      return {
        ...state,
        fetching: true
      };
    case cardTypesConstants.GET_CARDTYPES_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case cardTypesConstants.GET_CARDTYPES_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.error
      };
    case cardTypesConstants.GET_CARDTYPES_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
